var Util = /** @class */ (function () {
    function Util() {
    }
    /**
     * Returns decoded string with + replaced with ' ' and any other URL encoding decoded.
     * Note: This is really just meant to be used for individual strings. If you are wanting to decode
     * a URL query string, just use URLSearchParams directly. This function artificially creates a key=value
     * string and then gets the value to decode it.
     *
     * @param val
     * @returns decoded string
     */
    Object.defineProperty(Util, "normalize", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (val) {
            return new URLSearchParams("val=".concat(val)).get("val") || "";
        }
    });
    Object.defineProperty(Util, "normalizeBool", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (val) {
            return new URLSearchParams("val=".concat(val)).get("val") === "true";
        }
    });
    return Util;
}());
export default Util;
